/**
 * Created by Julio Perez on 5/24/2016.
 */
import FooterSectionController from './footer-section.controller';

function footerSection(){
    return {
        restrict: "E",
        scope: {
          name: '='
        },
        template: require('./footer-section.html'),
        controller: FooterSectionController,
        controllerAs: "ctrl"
    }
}

export default angular
    .module('footer-section.directive', [])
    .directive('footerSection', footerSection)
    .name;


// WEBPACK FOOTER //
// ./src/app/views/footer-section/footer-section.directive.js